var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fn-layout-vertical-conatiner app-container",
      staticStyle: { height: "calc(100%)" }
    },
    [
      _c("div", { staticClass: "fn-layout-vertical-form" }, [
        _c(
          "div",
          { staticClass: "vertical-form-cont fn-border-bottom" },
          [_vm._t("top-form")],
          2
        )
      ]),
      _vm._v(" "),
      _vm.operation
        ? _c("div", { staticClass: "fn-layout-vertical-operation" }, [
            _c(
              "div",
              { staticClass: "fn-layout-vertical-operation-item" },
              [_vm._t("left-btn")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fn-layout-vertical-operation-item" },
              [_vm._t("right-btn")],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "fnLayoutTable",
          staticClass: "fn-layout-vertical-table",
          staticStyle: { height: "calc(100%)" }
        },
        [_vm._t("tab-body")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fn-layout-vertical-pagination fn-border-top",
          staticStyle: { "justify-content": "space-between" }
        },
        [_vm._t("bottom-page")],
        2
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ee6d3f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee6d3f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout-body.vue
// module id = null
// module chunks = 